// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5554":"2eee3d216efd9040","6816":"9bc7bae2d3f03059"}[chunkId] + ".js";
};